<template>
  <section>
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              Measurables
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item active>
                  Manage
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="3"
        cols="12"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary" @click="showPay = true">
          Add New WebSite
        </b-button>
      </b-col>
    </b-row>
    <sites-with-admin-access/>
    <b-modal
      v-model="showPay"
      title="Paid feature only"
      ok-title="Close"
      ok-only
      centered
    >
      Please contact <a href="mailto:hello@hostmatic.io">hello@hostmatic.io</a> to add a new website.
    </b-modal>
  </section>
</template>

<script>
import SitesWithAdminAccess from './sites_with_admin_access.vue'

export default {
  components: { SitesWithAdminAccess },
  data() {
    return {
      showPay: false
    }
  },
  methods: {
    add_website() {
      this.$router.push('/all-web-sites/website/store')
    }
  }
}
</script>
